import CoreUtils from '../utils/CoreUtils';

export default class DataModel {
  constructor() {
    this.updatingProperties = {};
    this.propertyListenerEntries = [];
    this.eventListenerEntries = [];
  }

  dispose() {
    this.eventListenerEntries.forEach(
      eventEntry => {
        delete this[eventEntry.eventName];
        eventEntry.eventListeners = [];
      }
    );

    this.eventListenerEntries = [];
    this.propertyListenerEntries = [];
    this.updatingProperties = {};
  }

  onPropertyUpdated(propertyName, oldValue, newValue) { }

  createEvent(eventName) {
    var eventEntry = this.eventListenerEntries.find(
      entry => entry.eventName === eventName
    );

    if (eventEntry === undefined) {
      eventEntry = {
        eventName: eventName,
        eventListeners: []
      };

      this.eventListenerEntries.push(eventEntry);
      this[eventName] = (...args) => { this.invokeEvent(eventName, ...args); };
    }

    return eventEntry;
  }

  invokeEvent(eventName, ...args) {
    var eventEntry = this.eventListenerEntries.find(
      entry => entry.eventName === eventName
    );

    if (eventEntry === undefined)
      return;

    var listeners = Array.from(eventEntry.eventListeners);
    listeners.forEach(listener => listener(...args));
  }

  addEventListener(eventName, eventListener) {
    var eventEntry = this.createEvent(eventName);
    if (eventEntry.eventListeners.indexOf(eventListener) !== -1)
      return;

    eventEntry.eventListeners.push(eventListener);
  }

  removeEventListener(eventName, eventListener) {
    var eventEntry = this.eventListenerEntries.find(
      entry => entry.eventName === eventName
    );

    if (eventEntry === undefined)
      return;

    var listenerIndex = eventEntry.eventListeners.indexOf(eventListener);
    if (listenerIndex === -1)
      return;

    eventEntry.eventListeners.splice(listenerIndex, 1);
  }

  updateProperties(properties) {
    this.updatingProperties = {};

    CoreUtils.iterateProperties(
      properties,
      (propertyName, value) => this.queuePropertyUpdate(propertyName, value)
    );

    this.dispatchPropertyUpdates();
  }

  queuePropertyUpdate(propertyName, value) {
    if (value === this[propertyName])
      return;

    if (CoreUtils.isDefinedAndNotNull(this.updatingProperties[propertyName]))
      return;

    this.updatingProperties[propertyName] = {
      propertyName: propertyName,
      oldValue: this[propertyName],
      newValue: value
    };

    this[propertyName] = value;
  }

  dispatchPropertyUpdates() {
    Array.from(this.propertyListenerEntries)
      .forEach(
        entry => {
          if (CoreUtils.isUndefinedOrNull(entry.propertyNames))
            entry.listener();
          else {
            var propertyNames = CoreUtils.getObjectPropertyNames(this.updatingProperties)
              .filter(name => entry.propertyNames.includes(name));
            if (propertyNames.length > 0)
              entry.listener(propertyNames);
          }
        });

    CoreUtils.iterateProperties(
      this.updatingProperties,
      (_, propertyRecord) => {
        this.onPropertyUpdated
        (
          propertyRecord.propertyName,
          propertyRecord.oldValue,
          propertyRecord.newValue
        )
      }
    );

    this.updatingProperties = [];
  }

  addPropertyListener(propertyNames, propertyListener) {
    var matchedEntry = this.propertyListenerEntries.find(
      entry => entry.listener === propertyListener
    );

    if (matchedEntry !== undefined) {
      matchedEntry.propertyNames = propertyNames;
      return;
    }

    this.propertyListenerEntries.push({
      propertyNames: propertyNames,
      listener: propertyListener
    });
  }

  removePropertyListener(propertyListener) {
    var matchedEntry = this.propertyListenerEntries.find(
      entry => entry.listener === propertyListener
    );

    if (matchedEntry === undefined)
      return;

    this.propertyListenerEntries.splice(
      this.propertyListenerEntries.indexOf(matchedEntry),
      1
    );
  }
}